import type { ReactNode } from 'react';

/**
 * 카드 골격(재설계 §3.3) — 헤더(액션명·시각·scope·닫기) → 요지 1줄 → 본문(항목·작가 액션).
 * manuscript 1급 액션과 콘솔 의도가 같은 문법으로 결과를 돌려준다.
 */
export function CardShell({
  title,
  at,
  scope,
  summary,
  onClose,
  children,
}: {
  title: string;
  at: number;
  scope?: string;
  summary?: ReactNode;
  onClose?: () => void;
  children: ReactNode;
}) {
  return (
    <article className="rounded-md border border-line bg-bg-2/70 p-3">
      <div className="mb-1 flex items-center gap-2">
        <div className="field-key flex-1">{title}</div>
        <span className="mono text-[10px] text-fainter">
          {new Date(at).toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' })}
          {scope ? ` · ${scope}` : ''}
        </span>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label="카드 닫기"
            className="rounded px-1 text-[11px] text-fainter transition hover:text-dim"
          >
            ✕
          </button>
        )}
      </div>
      {summary && <p className="mb-2 text-[11px] leading-5 text-dim">{summary}</p>}
      <div className="space-y-2">{children}</div>
    </article>
  );
}
